export class bidEditorString {
  id?: number;
  fileContent?: string;
  fileName?: string;
}
